<div class="affiliate_page_wrap">
    <div class="affiliate_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="affi_top_contents">
                        <h1>推廣Trinka賺大錢！</h1>
                        <a id="signUpAtShareASale" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            在 ShareASale 上註冊
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="benefits_sections">
        <div class="benefits_outer">
            <div class="commission_sections">
                <div class="commission_header">
                    <img src="../../../assets/images/CommisionDetails.png" alt="commission">
                    <h2>傭金詳情</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <!-- <li>免費註冊-  $0.30</li> -->
                        <li>付費訂閱計畫 -  25%</li>
                    </ul>
                </div>
            </div>

            <div class="commission_sections OtherBenefits_section">
                <div class="commission_header">
                    <img src="../../../assets/images/otherBenefits.png" alt="trinka benefits">
                    <h2>其他福利</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <li>高轉化率 (20-25%)</li>
                            <li>跨設備追蹤</li>
                            <li>延長90天的cookie窗口</li>
                            <li>早期加入獎勵</li>
                            <li>頂級夥伴支持</li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Commision Details</h2>
                        <ul>
                            <li>Free Sign-ups - $0.21</li>
                            <li>Paid plan subscription - $20</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Other Benefits</h2>
                        <ul>
                            <li>Great conversion rates (20-30%)</li>
                            <li>Cross-device tracking</li>
                            <li>Extended 90-day cookie window</li>
                            <li>Early bird rewards</li>
                            <li>Top-class affiliate support</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div> -->
    </div>


    <div class="why_become_affiliate_sectioin">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h2>為什麼要加入聯盟行銷？</h2>
                    <div class="HeadingSubLine"></div>
                    <p>文法和語句更正是一項艱巨的任務，大多數線上語法檢查工具在學術和技術寫作方面都會遇到各種困難。Trinka利用人工智慧和機器學習技術以及數十年的行業專業知識，為作者提供撰寫無錯誤技術或學術論文所需的建議。Trinka是免費工具，可以線上使用，並且有瀏覽器外掛程式和 MS Word 外掛程式。</p>
                    <p>透過與Trinka合作，您不僅可以幫助學術專業人士和機構，還可以用少許的努力獲得穩定的收入。Trinka將幫助您處理所有繁重的工作，讓您繼續專注於自己最擅長的事，並以向作者提供最新和有用的內容和建議來維護客戶關係。</p>
                </div>
                <div class="col-md-3">
                    <div class="affiliate_img">
                        <img src="../../../assets/images/anAffiliate.png" alt="affiliate">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="Affiliate_FAQ_Seciton">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="faq_affiliate_sections">
                        <h2>聯盟行銷常見問題解答</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header" id="heading-1">
                                <h5 class="mb-0">
                                    <a role="button" data-toggle="collapse" href="#collapse-1" aria-expanded="true"
                                        aria-controls="collapse-1">
                                        關於Trinka聯盟行銷計畫
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-1" class="collapse show" data-parent="#accordion"
                                aria-labelledby="heading-1">
                                <div class="card-body">
                                    <p>Trinka聯盟行銷計畫以簡單高效的方式運作——您可以在網站或社交媒體、電子郵件、電子書等，放置橫幅或跟蹤文本連結。每次推薦用戶註冊Trinka時，您都可以獲得報酬。由於Trinka是免費的，您不需要過度銷售宣傳都可以得到收入。如實宣傳，加入連結就可以了，但當然業績更好的聯盟行銷夥伴能夠得到更高的報酬。</p>
                                    <p>如有任何疑問，請發送電子郵件至<a
                                            href="mailto:marketing@trinka.ai.">marketing@trinka.ai</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="heading-2">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-2"
                                        aria-expanded="false" aria-controls="collapse-2">
                                        誰可以成為Trinka聯盟行銷夥伴？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-2" class="collapse" data-parent="#accordion" aria-labelledby="heading-2">
                                <div class="card-body">
                                    <p>Trinka能幫助世界各地的學生、研究人員、科學家、專業人士、語言愛好者以及所有用英語寫作的人。Trinka 的聯盟行銷計畫與寫作相關的網站或部落格完美契合。此外我們還有一些積極的聯盟行銷夥伴，其內容強調教育、科學、技術、職業發展，以及吸引Trinka多元化用戶群的眾多其他領域。</p>
                                    <p>您可以通過創建與我們使命同步的內容並確保其相關性、結構合理和最新性，從而最大限度地利用我們聯盟行銷計畫帶來的好處。</p>
                                        
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-3">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-3"
                                        aria-expanded="false" aria-controls="collapse-3">
                                        我怎樣才能成為Trinka的聯盟行銷夥伴？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-3" class="collapse" data-parent="#accordion" aria-labelledby="heading-3">
                                <div class="card-body">
                                    <p>一旦您被接受加入該計畫，您將獲得一系列的附屬橫幅和連結。如果您願意，您可以使用即時通訊軟體和電子郵件來宣傳Trinka。</p>
                                    <p>當放置我們提供的橫幅或連結時，請確保您將其添加到最有價值和合適內容的頁面中。為了得到最好的使用者體驗，請不要將連結和橫幅放置在其他橫幅或連結旁邊。</p>
                                    <p>請不要為客戶提供加入Trinka的獎勵。</p>
                                    <p>此外，避免對商標“Trinka”或“Trinka.ai”或其任何變體（包括不正確的拼寫）進行競標。請避免在功能變數名稱或元標籤中使用這些商標名稱，也不要從按點擊付費的廣告中直接連結到我們的網站。</p>
                                    <p style="margin: 0;">最後，我們禁止對下列品牌和非品牌關鍵字進行投標：</p>
                                    <p>Trinka，Trinka AI，Trinka.AI，www.Trinka.AI，剽竊檢查，語法檢查，剽竊檢查，免費剽竊檢查，免費語法檢查，線上語法檢查，寫作助手，學術寫作助手，技術寫作助手，校對。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-4">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-4"
                                        aria-expanded="false" aria-controls="collapse-4">
                                        成為聯盟行銷夥伴有什麼好處？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-4" class="collapse" data-parent="#accordion" aria-labelledby="heading-4">
                                <div class="card-body">
                                    <p>每一次用戶付費升級時，會支付您25%的傭金。您網站上的每個連結都有一個特定的追蹤代碼，每次客戶透過您的網站點擊trinka.ai並安裝免費的Trinka瀏覽器擴展、註冊或升級到付費計畫，我們會記錄這些轉化並將收益分配到您的帳戶。您可以隨時從操作介面或ShareASale的報告部分查看您的轉化和收入。由於cookie政策延長至90天，用戶若在首次造訪網站後90天內付費升級，就會計入您的傭金。</p>
                                        <p>請注意所有付款將僅以美元支付。如果您不在美國，請確保您的銀行帳號能夠接收美元轉帳。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-5">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-5"
                                        aria-expanded="false" aria-controls="collapse-5">
                                        Trinka 聯盟行銷計畫的條款和條件是什麼？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-5" class="collapse" data-parent="#accordion" aria-labelledby="heading-5">
                                <div class="card-body">
                                    <p>請<a href="https://www.trinka.ai/termsofservices/"
                                        target="_blank">訪問此連結</a>閱讀我們的條款和條件。</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="bottom_shareAsale_buttons">
                        <a id="signUpAtShareASaleFooter" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            在 ShareASale 上註冊
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>